<template>
	<div>
		<div style="background-color: #fff;">
			<div class="member">
				<div v-if="dataList.length > 0">
					<div class="list flex" v-for="(item, i) in dataList" :key="i" @click="handleDetail(item)">
						<img class="left-img" :src="item.noticeUrl" alt="">
						<div class="right flex-1">
							<div class="top1">{{ item.noticeTitle || '-' }}</div>
							<div class="top2">{{ item.noticeDesc || '-' }}</div>
							<div class="top3 flex">
								<div class="top3-l flex-1">
									<span class="gray">作者：{{ item.author || '-' }}</span>
									<span class="type-tags">
										<span class="type-tag" v-for="(tag, idx) in (item.noticeTypeLabel || '').split(',')" :key="idx">{{ tag }}</span>
									</span>
								</div>
								<div class="top3-r gray">{{ item.createTime || '-' }}</div>
							</div>
						</div>
					</div>
					<div class="loading-more" v-if="hasMore">
						<span>加载更多...</span>
					</div>
					<div class="no-more" v-else>
						<span>没有更多了</span>
					</div>
				</div>
				<div v-else>
					<p>暂无数据</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import util from '@/utils/util';
export default {
	name: 'Index',
	data() {
		return {
			dataList: [],
			params: {
				page: 0,
				size: 10
			},
			hasMore: true,
			loading: false
		}
	},
	created() {
		this.getNoticeList()
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		getNoticeList() {
			if (this.loading || !this.hasMore) return
			
			this.loading = true
			util.request({
				url: `/sy/website/getNoticeList`,
				method: 'GET',
				params: this.params
			}).then(res => {
				const newData = res.data.content || []
				this.dataList = [...this.dataList, ...newData]
				
				// 判断是否还有更多数据
				if (newData.length < this.params.size) {
					this.hasMore = false
				}
				
				this.params.page++
			}).catch(error => {
				this.$message.error(error);
			}).finally(() => {
				this.loading = false
			});
		},
		handleScroll() {
			// 滚动到底部判断
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			const windowHeight = window.innerHeight
			const scrollHeight = document.documentElement.scrollHeight
			
			if (scrollTop + windowHeight >= scrollHeight - 100 && this.hasMore && !this.loading) {
				this.getNoticeList()
			}
		},
		handleDetail(item) {
			console.log(item.id)
			this.$router.push({
				path: '/pawnNewsDetail',
				query: {
					id: item.id
				}
			})
		}
	}
}
</script>

<style scoped>
.member {
	width: 1200px;
	margin: 0 auto;
	padding-top: 70px;
	padding-bottom: 70px;
}
.flex {
	display: flex;
	align-content: center;
}
.flex-1 {
	flex: 1;
}
.left-img {
	width: 156px;
	height: 156px;
	margin-right: 20px;
}
.top1 {
	font-weight: 600;
	font-size: 18px;
	color: #333333;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}
.top2 {
	font-size: 14px;
	color: #666666;
	margin-top: 10px;
	margin-bottom: 60px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.6;
}
.gray {
	font-size: 14px;
	color: #999999;
}
.type-tags {
	margin-left: 15px;
}
.type-tag {
	display: inline-block;
	padding: 1px 8px;
	font-size: 12px;
	color: #FE3D3A;
	background-color: rgba(254, 61, 58, 0.10);
	border-radius: 2px;
	margin-right: 8px;
}
.list {
	margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/view/pawnshopNews.vue